import PodSettings from './PodSettings';

export default PodSettings;
